import { render, staticRenderFns } from "./Creation_2_Characteristics.vue?vue&type=template&id=65b8b130&scoped=true&"
import script from "./Creation_2_Characteristics.vue?vue&type=script&lang=js&"
export * from "./Creation_2_Characteristics.vue?vue&type=script&lang=js&"
import style0 from "./Creation_2_Characteristics.vue?vue&type=style&index=0&id=65b8b130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8b130",
  null
  
)

export default component.exports